import { IAxisSidePreset } from '@/interfaces/powerMarkets/table/ITableDataConfig.ts';

export interface IAxisSideOption {
    label: string;
    value: 'left' | 'right';
}

export function getPresetAxisSideOptions (axisSide: string | IAxisSidePreset): Array<IAxisSideOption> | null {
    if (!Array.isArray(axisSide) || axisSide.length === 0) return null;

    return axisSide.map(axis => ({
        label: axis.item1,
        value: axis.item2 === 0 ? 'left' : 'right',
    }));
}
